// extracted by mini-css-extract-plugin
export default {"Header":"x9IzyP6ybSUZeYA2CfBm","HeaderContent":"xUagNdFcz8BUYrkg9q7g","Close":"kcv1PL2oC8HW8XkkSpZC","ModalBody":"EzAmev3Z39EE1cWjRTzR"};